import React, { Suspense } from "react";

import LoadingEffect from "./LoadingEffect";

import CategorySelectWrap from "./CategorySelectWrap";
import SelectSwitch from "./SelectSwitch";
import MainShowWrap from "./MainShowWrap";
import ResultWrap from "./ResultWrap";
import ButtonWrap from "./ButtonWrap";

import AllModalWrap from "./AllModalWrap";

import { getSelectedProduct } from "../utility/global";

export default class Main extends React.Component {
    componentDidUpdate(prevProps) {
        // console.log(prevProps)
        const updateSeletedStateAndAmount = () => {
            /**
             * 組出現在畫面上有的商品、準備送給簡易商品 api
             */
            const {
                planningData,
                selectedCategoryIndex,
                selectedState,
                postSimpleProductApi,
                isSendDesignCode,
            } = this.props;
            let selectedProduction = getSelectedProduct(
                planningData,
                selectedCategoryIndex,
                selectedState
            );
            /**
             * 組出現在畫面上有的商品、準備送給簡易商品 api 結束
             */

            if (selectedProduction.length !== 0 && !isSendDesignCode) {
                postSimpleProductApi(selectedProduction);
            }
        };

        if (this.props.selectedState !== prevProps.selectedState) {
            updateSeletedStateAndAmount();
        }
    }
    componentDidMount() {
        const {
            // function
            getPlanningData,
            // variable
        } = this.props;

        getPlanningData();
    }
    render() {
        const {
            // function
            setSelectedCategoryIndex,
            setSlideArray,
            resetSelected,
            resetReadyAddToCartList,
            updateSamePosition,
            updateIsSendDesignCode,
            updateGoToRow,
            updateListDataJson,
            updateLoadingStatus,
            updateShowResultStatus,
            updateShowGetProductionJsonModal,
            updateShowProductionListModal,
            updateShowPostProductionJsonModal,
            updateShowAddToCartProductListModal,
            postAddToCart,
            postSaveStatusApi,
            getSaveStatusApi,
            // variable
            isLoading,
            planningData,
            selectedCategoryIndex,
            selectedState,
            isReset,
            isGoToTheSamePosition,
            gotoRow,
            isSendDesignCode,
            isShowResult,
            isShowGetProductionJsonModal,
            isShowProductionListModal,
            isShowPostProductionJsonModal,
            isShowAddToCartProductListModal,
            totalAmount,
            listData,
            saveJson,
            readyAddToCartList,
            alreadyAddToCartList,
        } = this.props;

        return (
            <Suspense fallback={<div></div>}>
                <div className="container my-3">
                    <div className="row">
                        {/*
                         * 效果層
                         */}
                        <LoadingEffect isLoading={isLoading} />
                        {/*
                         * 上選單，切換選取分類
                         */}
                        {!planningData ? null : (
                            <CategorySelectWrap
                                resetSelected={resetSelected}
                                CategoryData={planningData.category}
                                selectedCategoryIndex={selectedCategoryIndex}
                                setSelectedCategoryIndex={
                                    setSelectedCategoryIndex
                                }
                                updateShowResultStatus={updateShowResultStatus}
                            />
                        )}

                        {/*
                         * 選取分類的第二層選取維度
                         */}
                        {isShowResult ? null : !planningData ? null : !planningData.category ? null : !planningData
                              .category[
                              selectedCategoryIndex
                          ] ? null : !planningData.category[
                              selectedCategoryIndex
                          ].categoryList ? null : (
                            <SelectSwitch
                                planningData={planningData}
                                SelectedCategoryFacets={
                                    planningData.category[selectedCategoryIndex]
                                        .categoryList
                                }
                                setSlideArray={setSlideArray}
                                selectedCategoryIndex={selectedCategoryIndex}
                                isReset={isReset}
                                selectedState={selectedState}
                                resetSelected={resetSelected}
                                isGoToTheSamePosition={isGoToTheSamePosition}
                                updateListDataJson={updateListDataJson}
                                updateSamePosition={updateSamePosition}
                                updateGoToRow={updateGoToRow}
                                gotoRow={gotoRow}
                                isSendDesignCode={isSendDesignCode}
                                updateIsSendDesignCode={updateIsSendDesignCode}
                            />
                        )}

                        {isShowResult ? null : !planningData ? null : !planningData.category ? null : !planningData
                              .category[selectedCategoryIndex] ? null : (
                            <MainShowWrap
                                isShowResult={isShowResult}
                                planningData={planningData}
                                CategoryData={
                                    planningData.category[selectedCategoryIndex]
                                }
                                setSlideArray={setSlideArray}
                                SelectedCategoryFacets={
                                    planningData.category[selectedCategoryIndex]
                                        .categoryList
                                }
                                // 選到第幾個分類
                                selectedCategoryIndex={selectedCategoryIndex}
                                // 該分類現在顯示為第幾個
                                selectedState={selectedState}
                                isReset={isReset}
                                resetSelected={resetSelected}
                                isGoToTheSamePosition={isGoToTheSamePosition}
                                updateSamePosition={updateSamePosition}
                                gotoRow={gotoRow}
                            />
                        )}

                        {/* 結果頁面 */}
                        {!isShowResult ? null : (
                            <ResultWrap
                                setSlideArray={setSlideArray}
                                isShowResult={isShowResult}
                                planningData={planningData}
                                // result 用得到的
                                CategoryData={
                                    planningData.category[selectedCategoryIndex]
                                }
                                // 選到第幾個分類
                                selectedCategoryIndex={selectedCategoryIndex}
                                // 該分類現在顯示為第幾個
                                selectedState={selectedState}
                                isReset={isReset}
                                isShowAddToCartProductListModal={
                                    isShowAddToCartProductListModal
                                }
                                resetSelected={resetSelected}
                                resetReadyAddToCartList={
                                    resetReadyAddToCartList
                                }
                                isGoToTheSamePosition={isGoToTheSamePosition}
                                updateSamePosition={updateSamePosition}
                                gotoRow={gotoRow}
                                updateIsSendDesignCode={updateIsSendDesignCode}
                                updateLoadingStatus={updateLoadingStatus}
                                updateShowResultStatus={updateShowResultStatus}
                                updateShowProductionListModal={
                                    updateShowProductionListModal
                                }
                                updateShowPostProductionJsonModal={
                                    updateShowPostProductionJsonModal
                                }
                                updateShowAddToCartProductListModal={
                                    updateShowAddToCartProductListModal
                                }
                                postSaveStatusApi={postSaveStatusApi}
                                postAddToCart={postAddToCart}
                                totalAmount={totalAmount}
                                listData={listData}
                                readyAddToCartList={readyAddToCartList}
                                alreadyAddToCartList={alreadyAddToCartList}
                            />
                        )}

                        {isShowResult ? null : (
                            <ButtonWrap
                                updateShowResultStatus={updateShowResultStatus}
                                updateShowGetProductionJsonModal={
                                    updateShowGetProductionJsonModal
                                }
                                updateShowProductionListModal={
                                    updateShowProductionListModal
                                }
                                isShowGetProductionJsonModal={
                                    isShowGetProductionJsonModal
                                }
                                isShowProductionListModal={
                                    isShowProductionListModal
                                }
                                totalAmount={totalAmount}
                            />
                        )}

                        {/* 所有 modal 存放區 */}
                        <AllModalWrap
                            isShowResult={isShowResult}
                            isLoading={isLoading}
                            listData={listData}
                            readyAddToCartList={readyAddToCartList}
                            alreadyAddToCartList={alreadyAddToCartList}
                            updateIsSendDesignCode={updateIsSendDesignCode}
                            updateShowGetProductionJsonModal={
                                updateShowGetProductionJsonModal
                            }
                            updateShowProductionListModal={
                                updateShowProductionListModal
                            }
                            updateShowPostProductionJsonModal={
                                updateShowPostProductionJsonModal
                            }
                            updateShowAddToCartProductListModal={
                                updateShowAddToCartProductListModal
                            }
                            isShowGetProductionJsonModal={
                                isShowGetProductionJsonModal
                            }
                            isShowProductionListModal={
                                isShowProductionListModal
                            }
                            isShowPostProductionJsonModal={
                                isShowPostProductionJsonModal
                            }
                            isShowAddToCartProductListModal={
                                isShowAddToCartProductListModal
                            }
                            saveJson={saveJson}
                            // 以下為 api 相關
                            selectedCategoryIndex={selectedCategoryIndex}
                            selectedState={selectedState}
                            getSaveStatusApi={getSaveStatusApi}
                        />
                    </div>
                </div>
            </Suspense>
        );
    }
}
